import WeatherDay from './weather-day'
export default WeatherDay
